const validateDownloadFormat = (params) => {
  if (params?.format && !["excel", "pdf"].includes(params.format)) {
    throw new Error("Invalid format. strictly allowed 'excel' or 'pdf'");
  }
};

export const createSalesApi = (api) => ({
  // Sales Quotation
  getSalesQuotations: (fpoId) => api.get(`/fpo/${fpoId}/quotation`),
  getSalesQuotationByVendor: (fpoId, vendorId) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/quotation`),
  getSalesQuotationById: (fpoId, vendorId, id) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/quotation/${id}`),
  createSalesQuotation: (fpoId, vendorId, data) => api.post(`/fpo/${fpoId}/vendor/${vendorId}/quotation`, data),
  updateSalesQuotation: (fpoId, vendorId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/quotation/${id}`, data),
  deleteSalesQuotation: (fpoId, vendorId, id) => api.delete(`/fpo/${fpoId}/vendor/${vendorId}/quotation/${id}`),
  downloadQuotationReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/quotation/download`, { params, responseType: "blob" });
  },

  // Sales Invoice
  getSalesInvoices: (fpoId) => api.get(`/fpo/${fpoId}/sales/invoice`),
  getSalesInvoiceByVendor: (fpoId, vendorId) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/sales/invoice`),
  getSalesInvoiceById: (fpoId, vendorId, id) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/sales/invoice/${id}`),
  createSalesInvoice: (fpoId, vendorId, data) => api.post(`/fpo/${fpoId}/vendor/${vendorId}/sales/invoice`, data),
  updateSalesInvoice: (fpoId, vendorId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/sales/invoice/${id}`, data),
  UpdateDeliveryChallan: (fpoId, vendorId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/challan/${id}`, data),
  deleteSalesInvoice: (fpoId, vendorId, id) => api.delete(`/fpo/${fpoId}/vendor/${vendorId}/salesInvoice/${id}`),
  downloadSalesInvoiceReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/sales/invoice/download`, { params, responseType: "blob" });
  },

  // Sales Return
  getSalesReturns: (fpoId) => api.get(`/fpo/${fpoId}/sales/return`),
  getSalesReturnBySales: (fpoId, vendorId, salesId) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/sales/${salesId}`),
  getSalesReturnById: (fpoId, vendorId, salesId, id) => api.get(`/fpo/${fpoId}/vendor/${vendorId}/sales/${salesId}/return/${id}`),
  createSalesReturn: (fpoId, vendorId, salesId, data) => api.post(`/fpo/${fpoId}/vendor/${vendorId}/sales/${salesId}`, data),
  updateSalesReturn: (fpoId, vendorId, salesId, id, data) => api.patch(`/fpo/${fpoId}/vendor/${vendorId}/sales/${salesId}/return/${id}`, data),
  deleteSalesReturn: (fpoId, vendorId, salesId, id) => api.delete(`/fpo/${fpoId}/vendor/${vendorId}/sales/${salesId}/return/${id}`),
  downloadDeliveryChallanReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/delivery-challan/download`, { params, responseType: "blob" });
  },
  downloadSalesReturnReport: (fpoId, params) => {
    validateDownloadFormat(params);
    return api.get(`/fpo/${fpoId}/sales/return/download`, { params, responseType: "blob" });
  },

  // Sales Stock Reports
  getSalesStockReport: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/sales/stock`, { params: { startDate, endDate } }),
  getSalesReturnReport: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/sales/return/stock`, { params: { startDate, endDate } }),
  getSalesOverallStock: (fpoId, startDate, endDate) => api.get(`/fpo/${fpoId}/sales/overall/stock`, { params: { startDate, endDate } }),
  downloadSalesOverallStockReport: (fpoId, startDate, endDate, format = "excel") =>
    api.get(`/fpo/${fpoId}/sales/registry/download`, { params: { startDate, endDate, format }, responseType: "blob" }),
});
